import PageHero from "@/components/PageHero";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Download, ExternalLink } from "lucide-react";

export default function Research() {
  const [papers, setPapers] = useState([]);
  useEffect(() => { api.get("/research").then((r) => setPapers(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="research-page">
      <PageHero eyebrow="Publications" title="Research Papers" subtitle="Selected publications across public health, ethics, and clinical practice." />
      <section className="section-y">
        <div className="container-x">
          <div className="border border-[hsl(var(--border-c))] divide-y divide-[hsl(var(--border-c))]">
            {papers.length === 0 && (
              <div className="p-10 text-center text-[hsl(var(--fg-muted))]">No publications added yet.</div>
            )}
            {papers.map((p, i) => (
              <article key={p.id} className="p-6 sm:p-8 grid sm:grid-cols-12 gap-6 hover:bg-[hsl(var(--bg-muted))] transition-colors"
                data-testid={`research-paper-${p.id}`}>
                <div className="sm:col-span-1 font-display text-3xl text-[hsl(var(--accent))]">{String(i + 1).padStart(2, "0")}</div>
                <div className="sm:col-span-9">
                  <h3 className="font-display text-2xl text-[hsl(var(--primary))]">{p.title}</h3>
                  <div className="text-xs uppercase tracking-widest mt-2 text-[hsl(var(--fg-muted))]">
                    {p.authors} {p.journal && `· ${p.journal}`} {p.year && `· ${p.year}`}
                  </div>
                  {p.summary && <p className="mt-3 text-[hsl(var(--fg-muted))] leading-relaxed">{p.summary}</p>}
                </div>
                <div className="sm:col-span-2 flex sm:justify-end items-start gap-3">
                  {p.url && p.url !== "#" ? (
                    <a href={p.url} target="_blank" rel="noreferrer"
                      className="inline-flex items-center gap-2 text-sm uppercase tracking-wider font-semibold text-[hsl(var(--accent))] hover:underline"
                      data-testid={`research-view-${p.id}`}>
                      <ExternalLink size={14} /> View
                    </a>
                  ) : (
                    <span className="inline-flex items-center gap-2 text-sm uppercase tracking-wider font-semibold text-[hsl(var(--fg-muted))]">
                      <Download size={14} /> Available
                    </span>
                  )}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
